<template>
  <div>
    <h4>Booker Pipe</h4>
    <div v-if="isBdrUser">
      <p class="text-bold mb-4">
        <span class="text-bold">Your referral link:</span>
        <a
          class="ml-1 text-primary"
          :href="`/bookerregistration/referrer/` + userId"
          target="_blank"
          >{{ baseUrl }}/bookerregistration/referrer/{{ userId }}</a
        >

        <button
          class="btn btn-primary btn-sm ml-3"
          @click="
            copyToClipboard(baseUrl + '/bookerregistration/referrer/' + userId)
          "
        >
          {{ $t("lang.label.copy") }}
        </button>
        <span v-if="copied" class="ml-2">{{ $t("lang.label.copied") }}!</span>
      </p>
    </div>

    <div v-else>
      <!-- Filter Section -->
      <div class="col-12 px-0">
        <div class="container-fluid w-100 mb-3 p-3 border bg-white rounded stats-wrapper">
          <div class="d-flex flex-wrap">
            <!-- CREATION MONTH FILTER -->
            <div class="w-25 input-group input-group-sm p-1">
              <div class="input-group-prepend">
                <span class="input-group-text" id="inputGroup-sizing-sm">Creation Month</span>
              </div>
              <date-picker
                id="creationMonthPicker"
                class="form-control"
                v-model="filtersPage.creationMonthFilter"
                :config="datePickerConfig"
                placeholder="Select Month (optional)"
              ></date-picker>
            </div>

            <!-- NAME FILTER -->
            <div class="w-25 input-group input-group-sm p-1">
              <div class="input-group-prepend">
                <span class="input-group-text" id="inputGroup-sizing-sm">Name</span>
              </div>
              <input type="text" v-model="filtersPage.nameFilter" class="form-control" placeholder="Enter name">
            </div>

            <!-- EMAIL FILTER -->
            <div class="w-25 input-group input-group-sm p-1">
              <div class="input-group-prepend">
                <span class="input-group-text" id="inputGroup-sizing-sm">Email</span>
              </div>
              <input type="text" v-model="filtersPage.emailFilter" class="form-control" placeholder="Enter email">
            </div>


            <!-- RECRUITER FILTER -->
            <div class="w-25 input-group input-group-sm p-1 treeselect-wrapper">
              <div class="input-group-prepend">
                <span class="input-group-text" id="inputGroup-sizing-sm">Recruiter</span>
              </div>
              <treeselect v-model="filtersPage.recruiterFilter" :options="recruiterOptions" :multiple="true"
                :loading="recruitersLoading" placeholder="Loading recruiters..." class="form-control inline-table">
              </treeselect>
            </div>

            <!-- COUNTRY FILTER -->
            <div class="w-25 input-group input-group-sm p-1 treeselect-wrapper">
              <div class="input-group-prepend">
                <span class="input-group-text" id="inputGroup-sizing-sm">Country</span>
              </div>
              <treeselect v-model="filtersPage.countryFilter" :options="countryOptions" :multiple="true"
                :loading="countriesLoading" placeholder="Loading countries..." class="form-control inline-table">
              </treeselect>
            </div>

            <div class="w-25 input-group input-group-sm p-1 treeselect-wrapper">
              <div class="input-group-prepend">
                <span class="input-group-text" id="inputGroup-sizing-sm"
                  >Booker Type</span
                >
              </div>
              <select class="form-control" v-model="filtersPage.booker_type">
                <option value="all">All Types</option>
                <option value="human">Human</option>
                <option value="ai_agent">Agent AI</option>
              </select>
            </div>

            <!-- FILTER BUTTON -->
            <div class="w-25 p-1 ml-auto">
              <div class="col-md-12 d-flex justify-content-end my-2">
                <button class="btn btn-success" :disabled="loading || loadingTotal" @click="applyFilters()">
                  <i class="icon-calendar-check-o mr-2"></i>
                  <small>Apply Filters</small>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Tabs :tabSelected="tabSelected" :tabs="tabs" @change="changeTab($event)" />
      <LoadingSpinner v-if="loading || loadingTotal || loadingContract" />

      <div v-else>
        <div class="row w-100 my-3 card p-2" v-if="!loading && !loadingTotal">
          <!-- paginacion y totales -->
          <div class="col-md-12">
            <div class="row my-2">
              <div class="col-md-12">
                <span class="mr-1">{{ $t("lang.label.results") }}:</span>
                <small v-if="total < 0" class="ml-1 text-primary mr-4"
                  >{{ $t("lang.search.calculating") }}...</small
                >
                <strong class="mr-5" v-else>{{ total }}</strong>
                <button class="ml-2 btn btn-sm btn-primary"
                    @click="getToDownload()"
                    :disabled="processingAllItems"
                    >
                    <span v-if="!processingAllItems">
                      Download csv
                    </span>
                    <span v-else>Processing...</span>
                </button>
                <div class="row">
                  <div class="col-md-12 text-center">
                    <Pagination
                      :total="total"
                      :totalpage="totalPageStep"
                      :model="pagination"
                      :limit="false"
                      :color="'primary'"
                      @changePage="getData"
                      key="paginationkey"
                    ></Pagination>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="mx-0 px-0 table-responsive">
            <Table
              v-if="userData.length > 0"
              class="mx-2 w-100"
              :headers="tableHeaders"
              :cols="tableCols"
              :data="userData"
              :checkbox="false"
              :notselect="true"
              :key="'pipe-' + tabSelected"
              @goToEditUser="goToEditUser"
              @typeFormInteractions="typeFormInteraction"
              @deleteInteraction="deleteInteraction"
              @showContract="getContractBooker($event)"
              @openModalRolePlay="openModalRolePlay($event)"
              @orderBy="orderBy"
            >
            </Table>
            <div class="row" v-else>
              <div class="col-sm-12 col-md-10 offset-md-1 text-center">
                <div class="alert alert-primary mx-5 my-2 px-2 py-4">
                  <h6>
                    <i class="fas fa-exclamation-triangle mr-2"></i>
                    No booker with status '{{ returnBDRName() }}' to show
                  </h6>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
      <Modal :name="'modalRolePlay'" :size="'70'" :max-width="'650'" :close="true">
        <BookerTestRolePlay :selectedUserId="userRolePlayId" :fromPipe="true"></BookerTestRolePlay>
      </Modal>
      <div ref="pdfContent" style="position: absolute; top: -9999px; left: -9999px;">
        <ContractBookerHtml :booker="contractBooker" />
      </div>
  </div>

</template>

<script>
import Tabs from "@/components/Common/Tabs.vue";
import Table from "@/components/Common/Table.vue";
import Pagination from "@/components/Common/Pagination.vue";
import { bookersService, usersService } from "@/_services";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import { mapState } from "vuex";
import ContractBookerHtml from "@/components/Account/ContractBookerHtml.vue";
import { pdfTermsAndConditionsMixin } from "@/_mixins/";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import moment from "moment";
import Modal from "@/components/Common/Modal.vue";
import BookerTestRolePlay from "../BDR/BookerTestRolePlay.vue";

export default {
  name: "BookerPipe",
  components: {
    Tabs,
    Table,
    LoadingSpinner,
    Pagination,
    ContractBookerHtml,
    Treeselect,
    Modal,
    BookerTestRolePlay,
  },
  mixins: [pdfTermsAndConditionsMixin],
  props: {},
  data() {
    //Screening > Onboarding > Standby > Booker Level 1 > Booker Level 2 > Booker Manager > Stopped > Rejected
    return {
      processingAllItems: false,
      origin: [
         { id: 1, text: 'lang.label.recommendation' },
         { id: 2, text: 'lang.label.facebook' },
         { id: 3, text: 'lang.label.linkedin' },
         { id: 4, text: 'lang.label.universite_catholique_madagascar' },
         { id: 5, text: 'lang.label.project_pair' },
         { id: 6, text: 'lang.label.other' }
      ],
      recruiterOptions: [],
      recruitersLoading: false,
      countryOptions: [],
      countriesLoading: false,
      total: -1,
      pagination: {
        imported: false,
        refreshlist: false,
        selectfirst: false,
        cantPerPage: 25,
        currentPage: 1,
      },
      filtersPage: {
        user_bdr_status_id: null,
        getTotal: 0,
        creationMonthFilter: "",
        nameFilter: "",
        emailFilter: "",
        recruiterFilter: [],
        countryFilter: [],
        booker_type: "all",
        order_field: null,
        order_dir: null,
      },
      datePickerConfig: {
        format: "YYYY-MM",
        viewMode: "months",
        minDate: moment('2025-01-01'),
        maxDate: moment().endOf("day"),
      },
      isReferrer: false,
      copied: false,
      baseUrl: window.location.origin,
      loading: true,
      loadingTotal: true,
      loadingContract: false,
      namePDF: 1,
      contractBooker: {
        Monday: [],
        Tuesday: [],
        Wednesday: [],
        Thursday: [],
        Friday: [],
        date: "",
        nameBooker: "",
      },
      userData: [],
      userDataAllItems: [],
      tabSelected: 1,
      nameInTabs: {},
      auxTabs: {},
      userRolePlayId: null,
      sharedPhonesRequestId: 0,
      tabs: {
        1: {
          id: 1,
          name: "Screening",
        },
        2: {
          id: "1-1",
          name: "Interviewed",
        },
        3: {
          id: 2,
          name: "Onboarding",
        },
        4: {
          id: 3,
          name: "Validated",
        },
        5: {
          id: 4,
          name: "Level 1",
        },
        6: {
          id: 5,
          name: "Booker Level 2",
        },
        7: {
          id: 15,
          name: "Booker Level 3",
        },
        8: {
          id: 16,
          name: "Booker Level 4",
        },
        9: {
          id: 6,
          name: "Booker Manager",
        },
        10: {
          id: 10,
          name: "Booker France",
        },
        11: {
          id: 11,
          name: "Booker Hivy",
        },
        12: {
          id: 14,
          name: "Props. Closing",
        },
        13: {
          id: 7,
          name: "Stopped",
        },
        14: {
          id: 8,
          name: "Rejected Interview",
        },
        15: {
          id: 12,
          name: "Rejected Trial",
        },
        16: {
          id: 13,
          name: "Outdated",
        },
      },
      headers: [
        {
          label: "Photo",
          percentage: "0.1%",
          class: "overflowhide",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 1,
        },
        {
          label: "Annotations",
          percentage: "0.1%",
          class: "overflowhide",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 1,
        },
        {
          label: "Name",
          percentage: "0.1%",
          class: "overflowhide",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 2,
        },
           {
          label: "Clients",
          percentage: "22.5%",
          class: "overflowhide",
          permission: ["AgencyBilling", "isBookerManager"],
          id: 2,
        },

        {
          label: "",
          percentage: "10.5%",
          class: "overflowhide",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 3,
        },
        {
          label: "Status",
          percentage: "10.5%",
          class: "overflowhide",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 3,
        },
        {
          label: "Days to expire",
          percentage: "10.5%",
          class: "overflowhide",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 21,
          field: "days_until_expire",
          orderby: true,
          order: "ASC",
        },
        {
          label: "Origin",
          percentage: "10.5%",
          class: "overflowhide",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 3,
        },
        {
          label: "Creation date",
          percentage: "12.5%",
          class: "overflowhide",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 4,
        },
        {
          label: "Email",
          percentage: "10.5%",
          class: "overflowhide",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 5,
        },
        {
          label: "Phone",
          percentage: "10.5%",
          class: "overflowhide",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 6,
        },
        {
          label: "Shared phone",
          percentage: "10.5%",
          class: "overflowhide",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 6,
        },
        // {
        //   label: "Setup Calls",
        //   percentage: "10.5%",
        //   class: "overflowhide",
        //   permission: ["AgencyBilling", "isBookerManager", "isBdr"],
        //   id: 6,
        // },
        {
          label: "Tasks Done",
          percentage: "10.5%",
          class: "overflowhide",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 6,
        },
        // {
        //   label: "VideoAsk",
        //   percentage: "10.5%",
        //   class: "overflowhide",
        //   permission: ["AgencyBilling", "isBookerManager", "isBdr"],
        //   id: 7,
        // },
        {
          label: "",
          percentage: "10.5%",
          class: "overflowhide",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 3,
        },
        {
          label: "Starting date",
          percentage: "10.5%",
          class: "overflowhide",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 8,
        },
        {
          label: "Cooptation",
          percentage: "10.5%",
          class: "overflowhide",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 9,
        },
        {
          label: "Country",
          percentage: "12.5%",
          class: "overflowhide",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 17,
        },
          {
          label: "Role Plays",
          percentage: "12.5%",
          class: "overflowhide",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 17,
        },
        {
          label: "Recruiter",
          percentage: "12.5%",
          class: "overflowhide",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 18,
        },
        {
          label: "Contract",
          percentage: "12.5%",
          class: "overflowhide",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 19,
        },
        {
          label: "Banking details",
          percentage: "12.5%",
          class: "overflowhide",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 20,
        }
      ],
      cols: [
        [
          {
            value: "avatar",
            type: "image",
            width: "25px",
          },
        ],
        [
          {
            value: "booker_notes",
            value2: "booker_level_id",
            type: "tooltipNote",
          },
        ],
        [
          {
            value_label: "name",
            value_emit: "id",
            type: "emit",
            emit: "goToEditUser",
          },
        ],
        [
          {
            value: "id",
            type: "imageSetClients",
          },
        ],
        [
          {
            value: "bdr_status",
            value2: "days_since_status_change",
            type: "iconIfPipe",
          },
        ],
        [
          {
            value: "bdr_status",
            value2: "days_since_status_change",
            value_label: "bdr_status",
            type: "itemBadge",
            class: "badge",
            colors: [
              {
                id: "1",
                label: "Screening",
                bgColor: "gray",
                textColor: "#FFFFFF",
              },
              {
                id: "2",
                label: "Onboarding",
                bgColor: "orange",
                textColor: "#FFFFFF",
              },
              {
                id: "3",
                label: "Validated",
                bgColor: "#008080",
                textColor: "#FFFFFF",
              },
              {
                id: "4",
                label: "Level 1",
                bgColor: "green",
                textColor: "#FFFFFF",
              },
              {
                id: "5",
                label: "Booker Level 2",
                bgColor: "#FF8C00",
                textColor: "#FFFFFF",
              },
              {
                id: "6",
                label: "Booker Manager",
                bgColor: "#4B0082",
                textColor: "#FFFFFF",
              },
              {
                id: "7",
                label: "Stopped",
                bgColor: "#B22222",
                textColor: "#FFFFFF",
              },
              {
                id: "8",
                label: "Rejected Interview",
                bgColor: "red",
                textColor: "#FFFFFF",
              },
              {
                id: "9",
                label: "Test",
                bgColor: "black",
                textColor: "#FFFFFF",
              },
              {
                id: "10",
                label: "Booker France",
                bgColor: "blue",
                textColor: "#FFFFFF",
              },
              {
                id: "11",
                label: "Booker Hivy",
                bgColor: "yellow",
                textColor: "black",
              },
              {
                id: "12",
                label: "Rejected Trial",
                bgColor: "red",
                textColor: "#FFFFFF",
              },
              {
                id: "13",
                label: "Outdated",
                bgColor: "#DCDCDC",
                textColor: "black",
              },
              {
                id: "14",
                label: "Props. Closing",
                bgColor: "#C6F505",
                textColor: "black",
              },
              {
                id: "15",
                label: "Booker Level 3",
                bgColor: "#279CF5",
                textColor: "#FFFFFF",
              },
              {
                id: "16",
                label: "Booker Level 4",
                bgColor: "#F5AD27",
                textColor: "#FFFFFF",
              },
              {
                id: "empty",
                label: "",
                bgColor: "white",
                textColor: "#FFFFFF",
              },
            ],
          },
        ],
        [
          {
            condition: "days_until_expire != null && days_until_expire <= 5",
            value_if: "days_until_expire",
            type: "bubble",
            class: "bg-danger text-white",
          },
          {
            condition: "days_until_expire != null && days_until_expire > 5",
            value_if: "days_until_expire",
            type: "bubble",
            class: "bg-secondary text-white",
          },
        ],
        [
          {
            value: "user_bdr_origin_id",
          },
        ],
        [
          {
            value: "creation_date",
          },
        ],
        [
          {
            value: "email",
          },
        ],
        [
          {
            value: "phone",
          },
        ],
        [
          {
            type: "badgeBookingSignal",
            value: "shared_phone_signal",
            labelField: "shared_phone_label",
            tooltipField: "shared_phone_tooltip",
          },
        ],
        // [
        //   {
        //     value1: "setup_call",
        //     value2: "setup_call_updated",
        //     type: "twoValueParenthesis",
        //   },
        // ],
        [
          {
            value: "verified_tasks",
          },
        ],
        // [
        //   {
        //     type: "multiple",
        //     conditions: [
        //       {
        //         value_if: "has_interaction",
        //         value: "1",
        //         class: "icon-video-camera text-primary mr-2",
        //         type: "icon",
        //         type2: "emit",
        //         emit: "typeFormInteractions",
        //       },
        //       {
        //         value_if: "has_interaction",
        //         value: "1",
        //         class: "icon-cross text-danger   mr-2",
        //         type: "icon",
        //         type2: "emit",
        //         emit: "deleteInteraction",
        //       },
        //     ],
        //   },
        //   {
        //     value: "typeform_date_created",
        //     class: "text-primary",
        //   },
        // ],
        [
          {
            value: "bdr_status",
            value2: "starting_date",
            type: "iconIfPipe",
          },
        ],
        [
          {
            value: "starting_date",
          },
        ],
        [
          {
            value: "isReferrer",
            show_text: "false",
            icons: [
              {
                icon_if_value: true,
                icon_true: "icon-check-circle text-success icon-small",
              },
              {
                icon_if_value: false,
                icon_true: "icon-times-circle text-danger icon-small",
              },
            ],
          },
        ],
          [
          {
            value: "country_name",
          },
        ],
        [
          {
            value: "role_plays",
          },
          {
            value: "hasRolePlay",
            value_if: true,
            class: "fas fa-volume-up ml-2",
            type: "emit",
            emit: "openModalRolePlay",
            value_emit: "id",
            // value1: "hasRolePlay",
            // btnId: "id",
            // emit: "openModalRolePlay",
            // type: "modeRolePlay"
          }
        ],
        [
          {
            value: "recruiter_name",
          },
        ],
        [
             {
              value_label: "Contract",
              label:"Download",
              value_emit: "id",
              class: "btn btn-sm btn-primary",
              type: "emit",
              emit: "showContract",
            }
        ],
        [
            {
                value_if: "saved_bank_detail",
                value: 0,
                class: "icon-cross text-danger",
                type: "icon",
            },
            {
                value_if: "saved_bank_detail",
                value: 1,
                class: "icon-checkmark text-success",
                type: "icon",
            }
        ],
      ],
    };
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.authentication.user,
    }),
    isBdrUser() {
      return (
        this.currentUser.team_role_id == 2 && this.currentUser.role_id == 2
      );
    },
    userId() {
      return this.currentUser.id;
    },
    totalPageStep() {
      return this.userData.length;
    },
    isScreeningTab() {
      return this.tabSelected == 1 || this.tabSelected == "1-1";
    },
    tableHeaders() {
      if (this.isScreeningTab) {
        return this.headers;
      }
      return this.headers.filter((h) => h.field !== "days_until_expire");
    },
    tableCols() {
      if (this.isScreeningTab) {
        return this.cols;
      }
      return this.cols.filter(
        (colg) =>
          !colg.some(
            (c) =>
              c.value === "days_until_expire" || c.value_if === "days_until_expire"
          )
      );
    },
  },
  methods: {
    getToDownload() {
        const allItems = 1; // cuando quieres pedir todos los resultados sin limite
        this.getData(allItems);
    },
    download() {

      const nameDocument = "report-booker-pipe.csv";

      //Tomo headers desde simpleheader
      const headers = this.tableHeaders.filter( el => el.label != 'Photo' && el.label != 'Shared phone').map(h => h.label);

      const fields = this.tableCols.filter(el => el[0].value != 'avatar' && el[0].value != 'shared_phone_signal').map( item => {
        const value = (item[0].value) ? item[0].value : (item[0].value_if || item[0].value_label);
        return value;
      })

      const rows = this.userDataAllItems.map( item => {
        return fields.map( col => {
          return item[col];
        }).map(v => `"${String(v !== undefined && v !== null ? v : '').replace(/"/g, '""')}"`).join(",");
      })

      const csv = `${headers.join(",")}\n${rows.join("\n")}`;
      const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.setAttribute("href", url);
      link.setAttribute("download", nameDocument);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

    hasPermissions(perm) {
      return this.$store.getters["authentication/hasPermissions"](perm);
    },
    openModalRolePlay(id){
      this.userRolePlayId = null;
      this.userRolePlayId = id;
      this.$modal.show("modalRolePlay");
    },
    typeFormInteraction(type) {
      const url =
        "https://app.videoask.com/app/organizations/aba166ca-2d19-488f-b7e2-5b7397250501/all-interactions?interactionId=" +
        type.typeform_interaction_id;
      window.open(url, "_blank");
    },
    changeTab(value) {
      if (value == this.tabSelected) return;
      this.tabSelected = value;
      this.user_bdr_status_id = value;
      this.pagination.cantPerPage = 25;
      this.pagination.currentPage = 1;
      this.filtersPage.order_field = null;
      this.filtersPage.order_dir = null;
      this.getData();
    },
    orderBy(event) {
      this.filtersPage.order_field = event.field;
      this.filtersPage.order_dir = event.order || "ASC";
      this.pagination.currentPage = 1;
      this.getData();
      this.headers.forEach((item) => {
        if (item.field == event.field) {
          item.order = item.order == "ASC" ? "DESC" : "ASC";
        }
      });
    },
    returnBDRName() {
      for (let id in this.tabs) {
        if (this.tabs[id].id == this.tabSelected) {
          return this.tabs[id].name;
        }
      }
    },
    isUserReferrer(data) {
      this.userData = data.map((user) => ({
        ...user,
        isReferrer: user.referrer_id !== null,
      }));
    },
    goToEditUser(user_id) {
      let url = "/users/" + user_id;
      window.open(url, "_blank");
    },
    getData(allItems = 0) {
      if (this.hasPermissions("isBdr")) {
        return;
      }
      if (allItems === 0) {
        this.getTotalData(allItems)
      }

      let videoAsk = 0;

      if (this.tabSelected == "1-1") {
        videoAsk = 1;
        this.filtersPage.user_bdr_status_id = 1;
      } else {
        this.filtersPage.user_bdr_status_id = this.tabSelected;
      }
      this.filtersPage.getTotal = 0;
      let filters = this.filtersPage;
      filters.cantPerPage = this.pagination.cantPerPage;
      filters.currentPage = this.pagination.currentPage;
      filters.user_bdr_status_id = this.filtersPage.user_bdr_status_id;
      filters.getTotal = this.filtersPage.getTotal;
      filters.videoAsk = videoAsk;
      filters.allItems = allItems
      if (allItems === 1) {
        this.processingAllItems = true
      }

      bookersService
        .getBookerPipe(filters)
        .then((res) => {
          res.result.list.forEach((element) =>{
              element.hasRolePlay = false;

              if(element.role_plays > 0 && element.role_plays != null){
                element.hasRolePlay = true;
              }

              if(allItems != 1){
                if(element.has_avatar == 1){
                let base64 = '';
                base64 = btoa(`usr-${element.id}`);
                element.avatar = process.env.VUE_APP_ROOT_API + '/redirect/image/' + base64;
                }else{
                  element.avatar = require('@/assets/images/emptyperson.png');
                }
              }

              const origin = this.origin.find( el => el.id === element.user_bdr_origin_id)
              element.user_bdr_origin_id = origin ? this.$t(origin.text) : this.$t('lang.label.not_available');
            })

            if(allItems === 1){
              this.userDataAllItems = res.result.list
              this.download();
              this.processingAllItems = false;
            } else {
              this.userData = res.result.list;
              if (this.userData != undefined) this.isUserReferrer(res.result.list);
              this.loading = false;
              this.getSharedPhones();
            }
        })
        .catch((err) => console.log(err));
    },
    getSharedPhones() {
      const ids = this.userData.map((user) => user.id);
      const requestId = ++this.sharedPhonesRequestId;
      if (ids.length === 0) return;

      bookersService
        .getBookerSharedPhones(ids)
        .then((res) => {
          if (requestId !== this.sharedPhonesRequestId) return;
          const sharedByUser = {};
          (res.result || []).forEach((item) => {
            sharedByUser[item.user_id] = item;
          });
          this.userData = this.userData.map((user) => {
            const shared = sharedByUser[user.id];
            if (!shared) return user;
            const accounts = shared.shared_with
              .map((account) => `${account.name} (#${account.id}, ${account.status})`)
              .join("; ");
            const more = shared.shared_more > 0 ? `; +${shared.shared_more} más` : "";
            return {
              ...user,
              shared_phone_signal: "reduce",
              shared_phone_label: `⚠ ${shared.shared_count} cuentas`,
              shared_phone_tooltip: `Este teléfono (${shared.phone_normalized}) figura en ${shared.shared_count} cuentas de candidato. Compartido con: ${accounts}${more}`,
            };
          });
        })
        .catch(() => {});
    },
    processResult(res) {
        res.result.list.forEach((element) =>{
              element.hasRolePlay = false;

              if(element.role_plays > 0 && element.role_plays != null){
                element.hasRolePlay = true;
              }

              if(allItems != 1){
                if(element.has_avatar == 1){
                let base64 = '';
                base64 = btoa(`usr-${element.id}`);
                element.avatar = process.env.VUE_APP_ROOT_API + '/redirect/image/' + base64;
                }else{
                  element.avatar = require('@/assets/images/emptyperson.png');
                }
              }

              const origin = this.origin.find( el => el.id === element.user_bdr_origin_id)
              element.user_bdr_origin_id = origin ? this.$t(origin.text) : this.$t('lang.label.not_available');
            })

            if(allItems === 1){
              this.userDataAllItems = res.result.list
              this.download();
              this.processingAllItems = false;
            } else {
              this.userData = res.result.list;
              if (this.userData != undefined) this.isUserReferrer(res.result.list);
              this.loading = false;
            }

    },
    getTotalData() {
      this.loadingTotal = true;
      let videoAsk = 0;

      this.filtersPage.user_bdr_status_id = this.tabSelected;
      if (this.tabSelected == "1-1") {
        videoAsk = 1;
        this.filtersPage.user_bdr_status_id = 1;
      }
      this.filtersPage.getTotal = 1;
      let filters = this.filtersPage;
      filters.cantPerPage = this.pagination.cantPerPage;
      filters.currentPage = this.pagination.currentPage;
      filters.user_bdr_status_id = this.filtersPage.user_bdr_status_id;
      filters.getTotal = this.filtersPage.getTotal;
      filters.videoAsk = videoAsk;

      bookersService
        .getBookerPipe(filters)
        .then((res) => {
          const totals = res.result.stats;
          this.total = -1;
          for (let item in totals) {
            if (totals[item].user_bdr_status_id === "1-1" && this.tabSelected == "1-1") {
              this.total = totals[item].total;
            }
          }
          if (this.total == -1){
            this.total = res.result.total;
          }

          if (totals != undefined && totals != null) {
            totals.forEach((item) => {
              const id = item.user_bdr_status_id;
              const total = item.total;
              const tabKey = this.auxTabs[id];

              if (this.nameInTabs[id]) {
                this.tabs[tabKey].name =
                  this.nameInTabs[id] + " (" + total + ")";
              }
            });
          }
          this.loadingTotal = false;
        })
        .catch((err) => console.log(err));
    },
    deleteInteraction(interaction) {
      const bookerId = interaction.id;
      this.$swal({
        type: "warning",
        title: this.$t("lang.label.areyousure"),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33a2c",
        confirmButtonText: this.$t("lang.button.yes"),
        cancelButtonText: this.$t("lang.button.cancel"),
      }).then((result) => {
        if (result.value) {
          console.log("interaction..", interaction);
          bookersService.removeInteraction(bookerId).then((res) => {
            this.$swal({
              title: this.$t("lang.label.success"),
              icon: "success",
            });

            this.getData();
          });
        }
      });
    },
    getContractBooker(bookerId) {
      this.loadingContract = true;
      this.contractBooker = {};
      this.userData.forEach((booker) => {
        if (booker.id == bookerId) {

          const workingDays = JSON.parse(booker.working_hours_availability);

          const monday = workingDays.find((day) => day.id === 0);
          const tuesday = workingDays.find((day) => day.id === 1);
          const wednesday = workingDays.find((day) => day.id === 2);
          const thursday = workingDays.find((day) => day.id === 3);
          const friday = workingDays.find((day) => day.id === 4);
          this.contractBooker.nameBooker = booker.name;
          this.contractBooker.Monday = monday ? monday.hours : [];
          this.contractBooker.Tuesday = tuesday ? tuesday.hours : [];
          this.contractBooker.Wednesday = wednesday ? wednesday.hours : [];
          this.contractBooker.Thursday = thursday ? thursday.hours : [];
          this.contractBooker.Friday = friday ? friday.hours : [];
          this.contractBooker.date = booker.signed_on;
          return;
        }
      })
      this.onModalOpened();
    },
    onModalOpened() {
      let ref = 1;
      this.$nextTick(() => {
        this.downloadTermsAndConditionsPDF(this.namePDF, ref).then(() => {
          this.loadingContract = false;
        });
      });
    },
    copyToClipboard(text) {
      console.log("url..", text);
      if (window.clipboardData && window.clipboardData.setData) {
        this.copied = true;
        setTimeout(() => {
          this.copied = false;
        }, 2000);
        return window.clipboardData.setData("Text", text);
      } else if (
        document.queryCommandSupported &&
        document.queryCommandSupported("copy")
      ) {
        var textarea = document.createElement("textarea");
        textarea.textContent = text;
        textarea.style.position = "fixed"; // Prevent scrolling to bottom of page in Microsoft Edge.
        document.body.appendChild(textarea);
        textarea.select();
        try {
          this.copied = true;
          setTimeout(() => {
            this.copied = false;
          }, 2000);
          return document.execCommand("copy"); // Security exception may be thrown by some browsers.
        } catch (ex) {
          console.warn("Copy to clipboard failed.", ex);
          return prompt("Copy to clipboard: Ctrl+C, Enter", text);
        } finally {
          document.body.removeChild(textarea);
        }
      }
    },
    getCountries() {
      this.countriesLoading = true;
      bookersService.getRecruiterCountries()
        .then((response) => {
          this.countryOptions = response.result || response;
          this.countriesLoading = false;
        })
        .catch((error) => {
          console.error("Error loading countries:", error);
          this.countriesLoading = false;
        });
    },
    getRecruiters() {
      this.recruitersLoading = true;
      usersService.getBookerRecruiters()
        .then((response) => {
          const recruiters = response.result || response;
          this.recruiterOptions = recruiters.map(recruiter => ({
            id: recruiter.id,
            label: recruiter.name
          }));
          this.recruitersLoading = false;
        })
        .catch((error) => {
          console.error("Error loading recruiters:", error);
          this.recruitersLoading = false;
        });
    },
    resetTabNames() {
      for (let key in this.tabs) {
        const status = this.tabs[key].id;
        if (this.nameInTabs[status]) {
          this.tabs[key].name = this.nameInTabs[status];
        }
      }
    },
    applyFilters() {
      this.resetTabNames();
      this.getTotalData();
      this.getData();
    },
  },
  created() {
    this.getCountries();
    this.getRecruiters();
    this.getData();
    if(!this.hasPermissions("isBdr")) {
      for (let key in this.tabs) {
        const status = this.tabs[key].id;
        this.auxTabs[status] = key;
        this.nameInTabs[status] = this.tabs[key].name;
      }
    }
  },
};
</script>

<style scoped>
.icon-small {
  font-size: 1rem !important;
}
</style>
